import "./UnitAndBody.module.css";
import Header from "@/reusable_sections/Header";
import UnitsHero from "./sections/UnitsHero";
import UnitsGrid from "./sections/UnitsGrid";
import Footer from "@/reusable_sections/Footer";
export default function UnitAndBodyPage() {
  return <div>
      <Header />
      <UnitsHero />
      <UnitsGrid />
      <Footer />
    </div>;
}